export var YesNoOptionID;
(function (YesNoOptionID) {
    YesNoOptionID["YES"] = "yes";
    YesNoOptionID["PARTIAL"] = "partial";
    YesNoOptionID["NO"] = "no";
})(YesNoOptionID || (YesNoOptionID = {}));
export var YesNoOptionLabel;
(function (YesNoOptionLabel) {
    YesNoOptionLabel["YES"] = "Yes";
    YesNoOptionLabel["PARTIAL"] = "Partial";
    YesNoOptionLabel["NO"] = "No";
})(YesNoOptionLabel || (YesNoOptionLabel = {}));
export var OperationSource;
(function (OperationSource) {
    OperationSource["API"] = "api";
    OperationSource["UI"] = "ui";
})(OperationSource || (OperationSource = {}));
//# sourceMappingURL=general.js.map